import ecocashLogo from '../../../../../../assets/ecocash.png'
import onemoneyLogo from '../../../../../../assets/onemoneypng.png'
import omariLogo from '../../../../../../assets/omari.png'
import innbucksLogo from '../../../../../../assets/innbuckspng.png'
import visaLogo from '../../../../../../assets/visa.jpg'
import mastercardLogo from '../../../../../../assets/mastercard.png'
import zimswitchLogo from '../../../../../../assets/zimswitch.png'
import paypalLogo from '../../../../../../assets/paypal.svg'

export interface Currency {
  code: string
  name: string
  symbol: string
}

export interface FormData {
  currency: string
  amount: string
  email: string
  paymentMethod: string
}



export interface PaymentMethod {
  id: string
  name: string
  icon?: React.ReactNode
  color?: string
  image?: string
}

export const PAYMENT_METHODS: PaymentMethod[] = [
  { id: 'ecocash', name: 'EcoCash', color: '#2563eb', image: ecocashLogo }, // Blue
  { id: 'onemoney', name: 'OneMoney', color: '#f97316', image: onemoneyLogo }, // Orange
  { id: 'omari', name: "O'Mari", color: '#22c55e', image: omariLogo }, // Green
  { id: 'innbucks', name: 'InnBucks', color: '#1e40af', image: innbucksLogo }, // Dark Blue
  { id: 'visa', name: 'Visa', color: '#4f46e5', image: visaLogo },
  { id: 'mastercard', name: 'Mastercard', color: '#ef4444', image: mastercardLogo },
  { id: 'zimswitch', name: 'ZimSwitch', color: '#d97706', image: zimswitchLogo },
  { id: 'paypal', name: 'PayPal / Card', color: '#0070ba', image: paypalLogo },
]

// PayPal routes to a different processor and a different UI (PayPal Smart
// Buttons + PayPal Card Fields). Use this set to switch the Form between
// the Paynow flow and the PayPal flow.
export const PAYPAL_METHOD_IDS = new Set(['paypal'])

// ZimSwitch routes to the OPPWA COPY&PAY hosted widget (legacy — superseded by
// EFT PAY for cards, kept for its own tile so nothing regresses).
export const ZIMSWITCH_METHOD_IDS = new Set(['zimswitch'])

// EFT PAY (EFT Corp / NMBZ OPPWA COPY&PAY) is the primary card + EcoCash path.
// Cards (Visa/Mastercard) settle via the 'card' channel (USD); EcoCash settles
// via the 'ecocash' channel (USD/ZWG). Both use the same hosted COPY&PAY widget.
export const EFTPAY_CARD_METHOD_IDS = new Set(['visa', 'mastercard'])
export const EFTPAY_ECOCASH_METHOD_IDS = new Set(['ecocash'])

export interface FormErrors {
  amount?: string
  email?: string
}

export type StoredDonation = Omit<Donation, "date"> & {
  date: string;
};



export interface Donation {
  id: string
  amount: number
  currency: string
  email: string
  paymentMethod: string
  status: 'Pending' | 'Completed' | 'Failed'
  date: Date
}

export const CURRENCIES: Currency[] = [
  { code: 'USD', name: 'US Dollars', symbol: '$' },
  { code: 'ZWG', name: 'Zimbabwe Gold', symbol: 'ZiG' },
]

export const STORAGE_KEY = 'recent_donations'

